import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const COLORS = {
  primary: '#2D5016',
  background: '#F5F7F3',
  text: '#2D3E1F',
  textLight: '#6B7F5C',
  white: '#FFFFFF',
};

const SignupSuccess = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    // Optional: Verify the session with Stripe
    console.log('Stripe session:', sessionId);
  }, [sessionId]);

  return (
    <div style={{
      minHeight: '100vh',
      background: COLORS.background,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem 1rem',
      fontFamily: 'Georgia, serif',
    }}>
      <div style={{
        maxWidth: '500px',
        background: COLORS.white,
        borderRadius: '8px',
        padding: '3rem 2rem',
        textAlign: 'center',
        boxShadow: '0 2px 8px rgba(45, 80, 22, 0.08)',
      }}>
        <img 
          src="https://static.wixstatic.com/media/9314d3_159f685fcc1f44588e64ebf570d57389~mv2.png"
          alt="Virbal"
          style={{ maxWidth: '200px', marginBottom: '2rem' }}
        />
        <div style={{
          width: '80px',
          height: '80px',
          borderRadius: '50%',
          background: COLORS.primary,
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '3rem',
          margin: '0 auto 2rem',
        }}>✓</div>
        <h2 style={{ fontSize: '2rem', color: COLORS.text, marginBottom: '1.5rem', fontWeight: 400 }}>
          Almost There!
        </h2>
        <p style={{
          color: COLORS.textLight,
          fontFamily: 'Inter, sans-serif',
          fontSize: '1.1rem',
          lineHeight: 1.6,
          marginBottom: '1rem',
        }}>
          Your payment is confirmed! We're setting up your account now.
        </p>
        <p style={{
          color: COLORS.textLight,
          fontFamily: 'Inter, sans-serif',
          fontSize: '1.1rem',
          lineHeight: 1.6,
          marginBottom: '2rem',
        }}>
          Your partner will receive a text with a link to complete their signup.
        </p>
        <div style={{
          padding: '1.5rem',
          background: 'rgba(45, 80, 22, 0.05)',
          borderRadius: '6px',
          marginTop: '2rem',
        }}>
          <p style={{
            color: COLORS.text,
            fontFamily: 'Inter, sans-serif',
            fontSize: '0.95rem',
            lineHeight: 1.6,
            margin: 0,
          }}>
            ✓ 7-day free trial started<br/>
            ✓ First charge on {new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toLocaleDateString()}<br/>
            ✓ Cancel anytime
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignupSuccess;
